import type { FeatureFlag, FeatureFlagSettings } from './types';

import { FF_ON } from './constants';

export const isFeatureEnabled = (
  featureFlags: FeatureFlag[] | undefined,
  settings: FeatureFlagSettings,
): boolean => {
  // Settings are null until the dashboard's config fetch resolves; treat an unknown flag as off
  // rather than briefly enabling a gated experience.
  if (!settings) {
    return false;
  }

  // A feature with no flags is always enabled.
  if (!featureFlags || featureFlags.length === 0) {
    return true;
  }

  // settings.yaml booleans reach the frontend as the strings '1'/'0'; the boolean comparison is
  // carried over from member-app's implementation to stay tolerant of either shape.
  return featureFlags.every((flag) => settings[flag] === true || settings[flag] === FF_ON);
};
